import { computed } from 'vue';
import { GET_META } from '#shared/types/getters';

export function useMeta() {
  const navHeader = useNavHeader();

  return { meta: computed(() => navHeader[GET_META]) };
}
